import React, { useState, useEffect } from "react";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { CircularProgress } from "@mui/material";

interface FirebaseImageProps {
  storagePath: string;
  alt?: string;
  width?: string | number;
  height?: string | number;
  className?: string;
  style?: React.CSSProperties;
}

const FirebaseImage: React.FC<FirebaseImageProps> = ({
  storagePath,
  alt = "画像",
  width,
  height,
  className,
  style,
}) => {
  const [imageUrl, setImageUrl] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchImageUrl = async () => {
      try {
        setLoading(true);
        const storage = getStorage();
        const imageRef = ref(storage, storagePath);
        const url = await getDownloadURL(imageRef);
        setImageUrl(url);
        setError(null);
      } catch (err) {
        console.error("画像の取得中にエラーが発生しました:", err);
        setError("画像を読み込めませんでした");
      } finally {
        setLoading(false);
      }
    };

    if (storagePath) {
      fetchImageUrl();
    }
  }, [storagePath]);

  if (loading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", padding: "1rem" }}
      >
        <CircularProgress size={24} />
      </div>
    );
  }

  if (error) {
    return <div style={{ fontSize: "1rem" }}>{error}</div>;
  }

  return (
    <img
      src={imageUrl}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={style}
    />
  );
};

export default FirebaseImage;
